import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';
// import { isNumber, toInteger, padNumber } from '@ng-boo @ng-bootstrap/ng-bootstrap/util/util';
 
@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct {
      if(value.length==2 || value.length==5){
        return {day:parseInt(value),month:0,year:0}
        
      }
      
    if (value) {
      const dateParts = value.trim().split('/');
      if (dateParts.length === 1) {
        return {day: parseInt(dateParts[0]), month: 0, year: 0};
      } else if (dateParts.length === 2) {
        return {day: parseInt(dateParts[0]), month: parseInt(dateParts[1]), year: 0};
      } else if (dateParts.length === 3 ) {
        return {day: parseInt(dateParts[0]), month: parseInt(dateParts[1]), year: parseInt(dateParts[2])};
      }
    }
    return {day:0,month:0,year:0};
  }
 
  format(date: NgbDateStruct): string {
    return date ?
        `${Number.isInteger(date.day) ? this.padNumber(date.day,2) : ''}/${Number.isInteger(date.month) ? this.padNumber(date.month,2) : ''}/${date.year}` :
        '';
  }

  padNumber(value:number,NoOfDigit:number){
      let paddingString = value.toString();
    return paddingString.padStart(NoOfDigit,'0');
  }
}